const $ = require("jquery");

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + ";path=/;domain=" + APP_DOMAIN;
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

let darkMode = getCookie('darkMode') || false
let darkModeState = false;

const button = document.querySelector(".dark-mode-toggle");

if(darkMode === "notset"){
    darkMode = window.matchMedia("(prefers-color-scheme: dark)");
}

// Toggles the "dark-mode" class
function toggleDarkMode(state) {
    darkModeState = (state === true || state === 'true');
    document.querySelector('body').classList.toggle("darkMode", darkModeState);
    if(darkModeState === true) {
        $("select[name='darkMode']").val("dark");
    }else{
        $("select[name='darkMode']").val("light");
    }
}

// Initial setting
toggleDarkMode(darkMode === 'true');

// Toggles the "dark-mode" class on click and sets localStorage state
button.addEventListener("click", () => {
    darkModeState = !darkModeState;
    toggleDarkMode(darkModeState);
    setCookie('darkMode', darkModeState, 3650)
    localStorage.setItem("darkMode", darkModeState);
});



// disable-comments
if (darkMode) {
    $("select[name='darkMode']").val("dark");
}else{
    $("select[name='darkMode']").val("light");
}
$("select[name='darkMode']").change(function(){
    if($(this).val() === "dark") {
        toggleDarkMode("true")
        setCookie('darkMode', "true", 3650)
        localStorage.setItem("darkMode", "true");
    }else{
        toggleDarkMode("false")
        setCookie('darkMode', "false", 3650)
        localStorage.setItem("darkMode", "false");
    }
})
